import React from 'react'
import Banner from '../MyComponent/Banner'
import Seo from '../MyComponent/Seo'
import { EditorialIntro, EditorialSections } from '../MyComponent/EditorialContent'
import { buildContent } from '../content/siteContent'

function BuildYour() {
  return (
    <main className="build-page">
      <Seo {...buildContent} />
      <EditorialIntro heading={buildContent.heading} intro={buildContent.intro} eyebrow="Your word, your story" />
      <div id="word-builder" className="word-builder-anchor">
        <Banner />
      </div>
      <EditorialSections sections={buildContent.sections} ariaLabel="How custom letter art is made" />
    </main>
  )
}

export default BuildYour
